module.exports = __webpack_public_path__ + "static/media/splash_small.65a875aa.jpg";